import React, { useEffect, useState, FC } from "react";
import { Button, message, Select, Input, Tooltip } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { formatNum, getFormValidatorErrText, repairFormatNum } from "@/utils/utils"
import { useRepairTemplateDetailsModel } from "./repairTemplateDetailsModels";
import { globalPrompt } from "@/components/message";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, vinOption, getVinItem } from "@/model/globalModel";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { ITopType } from "@/types/ScmTypes";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import moment, { Moment } from "moment"
import { debounce } from "lodash";
import { useRepairTemplateModel } from "../../repairTemplateModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { YHDetailNav } from "@/components/YHDetailNav";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useRepairTemplateModel();
    const {
        editDesc,
        detailAddForm,
        detailEditForm,
        detailLookForm,
        updateAddFormVal,
        updateEditFormVal,
        insertDetail,
        resetAddCatch,
        resetEditCatch,
        getDetailEditOne,
        detailMaterialAddList, setDetailMaterialAddList,
        detailItemAddList, setDetailItemAddList,
        detailItemEditList, setDetailItemEditList,
        detailMaterialEditList, setDetailMaterialEditList,
        setConsumeHistoryModel,
        setConsumeHistoryVisible,
        setRepairHistoryModel,
        setRepairHistoryVisible,
        formComputeRule,
        editDetail,
        saveLoading, setSaveLoading
    } = useRepairTemplateDetailsModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])

    useEffect(() => {
        return () => {
            !findNav("13-9-1") && resetAddCatch(mode);
            !findNav("13-9-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])
    const { getSelectedDictOne } = useDictModel();

    const save = () => {
        if (!formComputeRule(mode)) return;
        IFormRef.current?.validateFields().then(async res => {

            if (mode === "add") {
                const retData = await insertDetail(res)
                if (retData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    setSelectedRowKeys([retData.id as string])
                    setDescRows([retData])
                    setSelectedRow(retData)
                    resetAddCatch(mode)
                    goBack();
                    setSaveLoading(false)
                }
            } else if (mode === "edit") {
                await editDetail({ ...typeForm[mode], ...res })
                setSaveLoading(false)
            }
        }).catch(err => {
            setSaveLoading(false)
            message.warning(getFormValidatorErrText(err));
        })
    }


    const goBack = () => replaceNav(selectedNavId, "13-9")

    const rightChildren = <>
        {mode !== "look" &&
            <>
                <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_SAVE}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        loading={saveLoading}
                        onClick={debounce(() => { save() }, 900)}
                    >{saveLoading ? '保存中' : '保存'}</Button>
                </YhAuth>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={goBack}
                >返回</Button>
            </>}</>
    //服务性质
    const serviceTypeCodeChange = (value: string, option: ISelectOption) => {
        if (value) {
            option && onChange({ serviceTypeName: option.label, serviceTypeCode: option.value })
        }
    }
    const brandCodeChange = (value: string, option: ISelectOption) => {
        if (value) {
            option && onChange({ brandName: option.label, brandCode: option.value })
        }
    }
    const vehicleTypeCodeChange = (value: string, option: ISelectOption) => {
        if (value) {
            option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value })
        }
    }
    const title = '基础信息'
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        items: [
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "维修类型",
                fieldName: "serviceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE),
                onSelectChange: serviceTypeCodeChange,
                rules: [{ required: true, message: "维修类型" }]
            }, {
                type: FormItemTypeEnum.Select,//VEHICLE_BRAND
                fieldLabel: "车辆品牌",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
                onSelectChange: brandCodeChange,
                fieldName: "brandCode",
                rules: [{ required: true, message: "请输入车辆品牌" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                onSelectChange: vehicleTypeCodeChange,
                rules: [{ required: true, message: "请选择车辆类型" }]
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "工时费用",
            //     fieldName: "laborCost",
            //     disable: true,
            //     placeholder: "自动生成",
            // }, {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "用料费用",
            //     fieldName: "materialCost",
            //     disable: true,
            //     placeholder: "自动生成",
            // }, 
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "remarks",
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型",
                fieldName: "serviceTypeName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆品牌",
                fieldName: "brandName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeName",
                hidden: true
            },
        ]
    };
    const otherFormItem: IYhFormItemsBox = {
        title: "其它信息",
        style: { marginTop: "10px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true
            }
        ]
    }
    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updateEditFormVal(changedValues)
    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelAlign: "right",
        disabled: mode == 'look',
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem, otherFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        {mode == 'add' ? '新增维修模版' : mode == 'edit' ? '编辑维修模版' : '查看维修模版'}
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}